<template>
  <MapModal
    :modalNode="modalNode"
    :close="cancel"
    :title="stationQueryTitle"
    id="stationQuery"
  >
    <template slot="content">
      <div class="stationQueryForm">
        <schemeDesignLine
          ref="schemeDesignLine"
          @getPlanGuid="getPlanGuid($event)"
          @getDesignLineGuid="getDesignLineGuid($event)"
        ></schemeDesignLine>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="查询桩号" class="is-required">
            <el-input
              v-model="form.stake"
              placeholder="请输入桩号"
            ></el-input> </el-form-item
        ></el-form>
      </div>
    </template>
    <template slot="foot">
      <div class="foot-operate">
        <el-button type="primary" @click="onSubmit">
          查询
        </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const schemeDesignLine = () =>
  import("@/components/tables/routeInteraction/schemeDesignLine.vue");

import { getStakeByBLHService, getPointService } from "@/api/api";
import * as mapWork from "./map.js";

export default {
  name: "station-query",
  components: { MapModal, schemeDesignLine },
  props: ["close"],
  data() {
    return {
      stationQueryTitle: "桩号查询",
      modalNode: {
        trafficSimulationAdd: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
          },
          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      planGuid: null,
      designLineGuid: null,
      form: {
        stake: null,
      },
    };
  },
  methods: {
    cancel() {
      mapWork.init();
      this.close();
    },
    getPlanGuid(data) {
      this.planGuid = data;
    },
    getDesignLineGuid(data) {
      this.designLineGuid = data;
    },
    // 确定
    onSubmit() {
      if (!this.$refs.schemeDesignLine.requiredCheck("form")) return;
      if (this.form.stake == null) {
        return this.$notify({
          title: "请输入查询桩号",
          message: "",
          type: "error",
          duration: 1000,
          offset: 320,
        });
      }
      mapWork.init();
      const params = {
        planGuid: this.planGuid,
        designLineGuid: this.designLineGuid,
        stake: this.form.stake,
      };
      getPointService(params)
        .then((res) => {
          let { stake, b, l, h } = res.data.data;
          mapWork.drawDots([
            {
              position: [l, b, h],
              text: stake,
            },
          ]);
        })
        .catch((error) => {
          this.$notify({
            title: "查询失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },
  },
  destroyed() {
    this.cancel();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.el-form {
  width: 100%;
  padding: 0 !important;
  /deep/ .el-radio-group {
    margin-top: 7px !important;
  }
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin: 20px 0px;
    margin-top: 0;
    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding-right: 10px;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      min-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-input {
        @include input_base();
        width: auto;
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: auto;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            // @include font_color("t_color_sc1");
            // @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            background-color: rgba(42, 183, 255, 0.4) !important;
            color: rgba(255, 255, 255, 0.9) !important;
            &:hover {
              background-color: rgba(42, 183, 255, 0.4) !important;
            }
            span {
              background: none;
              // @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    // &:first-child {
    //   padding: 10px 0 0 18px;
    // }
  }
  .main .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 20px;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}
.flexRight {
  display: flex;
  padding: 20px 0px;
  margin-right: -16px;
  align-items: center !important;
  width: 100%;
  justify-content: flex-end;
}
/deep/ .el-form.settings,
.el-form {
  padding: 0;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  .el-button {
    margin: 0 5px;
    font-size: 12px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.stationQueryForm {
  padding: 8px 36px 17px 0;
}
</style>
